export const clientReviews = [
  {
    name: "Nike Oyedeji",
    company: "CEO Of KITCHEN234",
    review:
      "My overall experience working with BildUp was excellent. You demonstrated a clear understanding of my brand and target audience, consistently delivering creative and well-aligned strategies. Your professionalism, attention to detail, and innovative approach were instrumental in strengthening my business's online presence.",
  },
  {
    name: "Mr Chucs Ahiakwo",
    company: "KashRite",
    review:
      "Joke contributed much value to my organization, helping us stay in the customer's face and to do business with us. Co-founder of KashRite",
  },
  {
    name: "Mr Oghenetega Michael Onodarho",
    company: "Founder & CEO, Integrated Healthcare Professionals Ltd",
    review:
      "She consistently delivers excellent marketing and social media results for my UK customers.",
  },
];
